import { render, staticRenderFns } from "./DetailsCycleItem.vue?vue&type=template&id=37dd5b44&scoped=true&"
import script from "./DetailsCycleItem.vue?vue&type=script&lang=js&"
export * from "./DetailsCycleItem.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCycleItem.vue?vue&type=style&index=0&id=37dd5b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dd5b44",
  null
  
)

export default component.exports